import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Returns the list of ISO dates ('YYYY-MM-DD') already used by ANY of the given
 * people for a form category, so the date picker can gray them out. Refetches
 * whenever the selected people change.
 *
 * @param {string} formType  - e.g. 'leave', 'overtime'
 * @param {string[]} names    - selected person names
 * @param {string} [excludeId] - submission id to ignore (edit mode)
 */
export default function useUsedDates(formType, names, excludeId) {
  const [dates, setDates] = useState([]);
  const list = (names || []).filter(Boolean);
  const key = list.join(',');

  useEffect(() => {
    let active = true;
    if (!formType || list.length === 0) {
      setDates([]);
      return undefined;
    }
    axios
      .get(`${API}/forms/used-dates`, {
        params: { form_type: formType, names: key, exclude_id: excludeId || undefined },
      })
      .then((r) => {
        if (active) setDates(Array.isArray(r.data?.dates) ? r.data.dates : []);
      })
      .catch(() => {
        if (active) setDates([]);
      });
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formType, key, excludeId]);

  return dates;
}
